import * as actionTypes from '../types/admin';

const initialState = {
  loadingUser: false,
  loadingRole: false,
  loadingVisits: false,
  loadingPermissions: false,
  loadingPermissionValues: false,
  listUsers: [],
  listUsersOnRole: [],
  listRoles: [],
  listRolesOnUser: [],
  listStatuses: [],
  listPieces: [],
  listVisits: [],
  listPermissionsOnRole: [],
  listPermission: [],
  listPermissionValues: [],

  dataAddRole: {
    loading: false,
    okRequest: false
  },
  dataCreateRole: {
    loading: false,
    okRequest: false
  },
  dataAddPermission: {
    loading: false,
    okRequest: false
  },
  dataDelRole: {
    loading: false,
    okRequest: false
  },
  dataDelPermission: {
    loading: false,
    okRequest: false
  },
  dataAddOrEditUser: {
    loading: false,
    okRequest: false,
    data: null
  },
  dataEditRole: {
    loading: false,
    okRequest: false
  },
  dataGetPieces: {
    loading: false,
    okRequest: false
  },
  dataChangePlant: {
    loading: false,
    okRequest: false
  },
  dataChangeStatus: {
    loading: false,
    okRequest: false
  },
  dataGetStatuses: {
    loading: false,
    okRequest: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_USERS_LIST:
      return {
        ...state,
        loadingUser: true
      };
    case actionTypes.GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        listUsers: payload
      };
    case actionTypes.GET_USERS_LIST_FAIL:
      return {
        ...state,
        loadingUser: false
      };

    case actionTypes.GET_USERS_ON_ROLE:
      return {
        ...state,
        loadingUser: true
      };
    case actionTypes.GET_USERS_ON_ROLE_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        listUsersOnRole: payload
      };
    case actionTypes.GET_USERS_ON_ROLE_FAIL:
      return {
        ...state,
        loadingUser: false
      };

    case actionTypes.GET_ROLES_ON_USER:
      return {
        ...state,
        loadingRole: true
      };
    case actionTypes.GET_ROLES_ON_USER_SUCCESS:
      return {
        ...state,
        loadingRole: false,
        listRolesOnUser: payload,
        dataAddRole: {
          ...state.dataAddRole,
          okRequest: false
        }
      };
    case actionTypes.GET_ROLES_ON_USER_FAIL:
      return {
        ...state,
        loadingRole: false
      };
    case actionTypes.GET_ROLES_LIST:
      return {
        ...state,
        loadingRole: true
      };
    case actionTypes.GET_ROLES_LIST_SUCCESS:
      return {
        ...state,
        loadingRole: false,
        listRoles: payload
      };
    case actionTypes.GET_ROLES_LIST_FAIL:
      return {
        ...state,
        loadingRole: false
      };

    case actionTypes.UPDATE_ROLE:
      return {
        ...state,
        dataEditRole: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        dataEditRole: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.UPDATE_ROLE_CLEAR:
    case actionTypes.UPDATE_ROLE_FAIL:
      return {
        ...state,
        dataEditRole: {
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.ADD_ROLE_ON_USER:
      return {
        ...state,
        dataAddRole: {
          ...state.dataAddRole,
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.ADD_ROLE_ON_USER_SUCCESS:
      return {
        ...state,
        dataAddRole: {
          ...state.dataAddRole,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.ADD_ROLE_ON_USER_FAIL:
    case actionTypes.CREATE_ROLE:
      return {
        ...state,
        dataCreateRole: {
          ...state.dataCreateRole,
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.CREATE_ROLE_SUCCESS:
      return {
        ...state,
        dataCreateRole: {
          ...state.dataCreateRole,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.CREATE_ROLE_FAIL:
    case actionTypes.CREATE_ROLE_CLEAR:
    case actionTypes.ADD_ROLE_ON_USER_CLEAR:
      return {
        ...state,
        dataCreateRole: {
          ...state.dataCreateRole,
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.DELETE_ROLE_ON_USER:
      return {
        ...state,
        dataDelRole: {
          ...state.dataDelRole,
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.DELETE_ROLE_ON_USER_SUCCESS:
      return {
        ...state,
        dataDelRole: {
          ...state.dataDelRole,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.DELETE_ROLE_ON_USER_FAIL:
    case actionTypes.DELETE_ROLE_ON_USER_CLEAR:
      return {
        ...state,
        dataDelRole: {
          ...state.dataDelRole,
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.CREATE_OR_UPDATE_USER:
      return {
        ...state,
        dataAddOrEditUser: {
          ...state.dataAddOrEditUser,
          loading: true,
          okRequest: false,
          data: null
        }
      };
    case actionTypes.CREATE_OR_UPDATE_USER_SUCCESS:
      return {
        ...state,
        dataAddOrEditUser: {
          ...state.dataAddOrEditUser,
          loading: false,
          okRequest: true,
          data: payload
        }
      };
    case actionTypes.CREATE_OR_UPDATE_USER_FAIL:
    case actionTypes.CREATE_OR_UPDATE_USER_CLEAR:
      return {
        ...state,
        dataAddOrEditUser: {
          ...state.dataAddOrEditUser,
          loading: false,
          okRequest: false,
          data: null
        }
      };
    case actionTypes.GET_PIECES_LIST:
      return {
        ...state,
        dataGetPieces: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_PIECES_LIST_SUCCESS:
      return {
        ...state,
        listPieces: payload,
        dataGetPieces: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_PIECES_LIST_FAIL:
      return {
        ...state,
        dataGetPieces: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.CHANGE_PIECES_PLANT:
      return {
        ...state,
        dataChangePlant: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.CHANGE_PIECES_PLANT_SUCCESS:
      return {
        ...state,
        dataChangePlant: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.CHANGE_PIECES_PLANT_FAIL:
      return {
        ...state,
        dataChangePlant: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.CHANGE_PIECES_STATUS:
      return {
        ...state,
        dataChangeStatus: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.CHANGE_PIECES_STATUS_SUCCESS:
      return {
        ...state,
        dataChangeStatus: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.CHANGE_PIECES_STATUS_FAIL:
      return {
        ...state,
        dataChangeStatus: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_STATUSES_LIST:
      return {
        ...state,
        dataGetStatuses: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_STATUSES_LIST_SUCCESS:
      return {
        ...state,
        listStatuses: payload,
        dataGetStatuses: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_STATUSES_LIST_FAIL:
      return {
        ...state,
        dataGetStatuses: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_VISITS_USER:
      return {
        ...state,
        loadingVisits: true
      };
    case actionTypes.GET_VISITS_USER_SUCCESS:
      return {
        ...state,
        loadingVisits: false,
        listVisits: payload
      };
    case actionTypes.GET_VISITS_USER_FAIL:
    case actionTypes.GET_VISITS_USER_CLEAR:
      return {
        ...state,
        loadingVisits: false,
        listVisits: []
      };

    case actionTypes.GET_PERMISSIONS_ON_ROLE:
      return {
        ...state,
        loadingPermissions: true
      };
    case actionTypes.GET_PERMISSIONS_ON_ROLE_SUCCESS:
      return {
        ...state,
        loadingPermissions: false,
        listPermissionsOnRole: payload
      };
    case actionTypes.GET_PERMISSIONS_ON_ROLE_FAIL:
      return {
        ...state,
        loadingPermissions: false
      };

    case actionTypes.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        listPermissions: payload
      };

    case actionTypes.GET_PERMISSION_VALUES:
      return {
        ...state,
        loadingPermissionValues: true
      };
    case actionTypes.GET_PERMISSION_VALUES_SUCCESS:
      return {
        ...state,
        loadingPermissionValues: false,
        listPermissionValues: payload
      };
    case actionTypes.GET_PERMISSION_VALUES_FAIL:
      return {
        ...state,
        loadingPermissionValues: false
      };

    case actionTypes.ADD_PERMISSION_ON_ROLE:
      return {
        ...state,
        dataAddPermission: {
          ...state.dataAddPermission,
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.ADD_PERMISSION_ON_ROLE_SUCCESS:
      return {
        ...state,
        dataAddPermission: {
          ...state.dataAddPermission,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.ADD_PERMISSION_ON_ROLE_FAIL:
    case actionTypes.ADD_PERMISSION_ON_ROLE_CLEAR:
      return {
        ...state,
        dataAddPermission: {
          ...state.dataAddPermission,
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.DELETE_PERMISSION_ON_ROLE:
      return {
        ...state,
        dataDelPermission: {
          ...state.dataDelPermission,
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.DELETE_PERMISSION_ON_ROLE_SUCCESS:
      return {
        ...state,
        dataDelPermission: {
          ...state.dataDelPermission,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.DELETE_PERMISSION_ON_ROLE_FAIL:
    case actionTypes.DELETE_PERMISSION_ON_ROLE_CLEAR:
      return {
        ...state,
        dataDelPermission: {
          ...state.dataDelPermission,
          loading: false,
          okRequest: false
        }
      };
    default:
      return state;
  }
};
export default reducer;
